
<!-- Start Page Title Area -->
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">{{home}}</a></li>
                <li>{{instructors}}</li>
            </ul>
            <h2>{{instructors}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Team Area -->
<section class="team-area pt-100 pb-70">

    <app-small-spinner [show]="showSpinner"></app-small-spinner>
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6"  *ngFor="let teacher of teachers">
                <app-teacher-item (routeToTeacherDetail)="routeToTeacherDetail($event)" [teacher]="teacher">
                </app-teacher-item>
            </div>

        </div>
    </div>
    
</section>
<!-- End Team Area -->